import { AzureDataBricksLinkedService } from './../../linkedservice/azure-data-bricks.linkedservice';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { ActivityAsyncAdapter } from './activity.adapter';
import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { ReferenceAdapter } from '../reference.adapter';
import { ValueAdapter } from '../value.adapter';
import _ from 'lodash';
import { SparkJarActivity } from 'app/model/pipeline/spark-jar.activity';
import { databricksParameterToResource, databricksParameterToModel } from 'app/model/pipeline/databricks-parameter.util';
import { databricksLibraryWithExpressionToResource, databricksLibraryWithExpressionToModel, databricksLibraryToModel } from 'app/model/pipeline/databricks-library.util';
import { convertParametersToModel } from 'app/shared/utils/parameter-converter.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SparkJarActivity),
    asynchronous: true,
    adapts: {
        name: '*',
        description: '*',
        type: '*',
        linkedServiceName: '*',
        policy: '*',
        dependsOn: '*',
        userProperties: '*',
        typeProperties: {
            mainClassName: '*',
            parameters: '*',
            libraries: '*'
        }
    }
})
export class JarActivityAdapter extends ActivityAsyncAdapter<SparkJarActivity, Model.DatabricksJarActivity> {

    public model(): IModel {
        return Metamodel.modelFor(SparkJarActivity);
    }

    protected async _toResource(activity: SparkJarActivity): Promise<Model.DatabricksJarActivity> {
        const resource: Model.DatabricksJarActivity = super._getCommonActivityProperties(activity, Metamodel.modelFor(SparkJarActivity).name) as Model.DatabricksJarActivity;

        resource.typeProperties = {
            mainClassName: ValueAdapter.toResource(activity, SparkJarActivity.MAIN_CLASS_NAME),
            parameters: databricksParameterToResource(activity.parameters),
            libraries: databricksLibraryWithExpressionToResource(activity.libraries, SparkJarActivity.LIBRARIES.templateValue(activity))
        };

        if (activity.linkedService) {
            resource.linkedServiceName = this._toLinkedServiceReferenceModel(activity.linkedService, activity.linkedServiceParameters);
        }

        if (activity.raw) {
            const parsed = JSON.parse(activity.raw);
            _.merge(resource, parsed);
        }

        return resource;
    }

    protected async _toModel(modelActivity: Model.DatabricksJarActivity): Promise<SparkJarActivity> {
        const activity: SparkJarActivity = new SparkJarActivity(modelActivity.name);
        const resource = modelActivity as Model.DatabricksJarActivity;

        this._updatedCommonProperties(modelActivity, activity);

        if (resource.typeProperties) {
            ValueAdapter.toModel(activity, SparkJarActivity.MAIN_CLASS_NAME, resource.typeProperties.mainClassName);
            activity.parameters = databricksParameterToModel(modelActivity.typeProperties.parameters, activity);
        }

        if (resource.linkedServiceName != null) {
            activity.linkedService = ReferenceAdapter.toProxyModel<AzureDataBricksLinkedService>(Metamodel.modelFor(AzureDataBricksLinkedService),
                resource.linkedServiceName, this.context);
            if (resource.linkedServiceName.parameters) {
                // Parameter value for linked service
                convertParametersToModel(activity,
                    !!this.context.adapterConfig.replaceIdentitiesForNonConcepts,
                    activity.linkedService,
                    activity.linkedServiceParameters,
                    resource.linkedServiceName.parameters);
            }
        }

        if (modelActivity.typeProperties && modelActivity.typeProperties.libraries) {
            databricksLibraryWithExpressionToModel(modelActivity.typeProperties.libraries, SparkJarActivity.LIBRARIES, activity, () => {
                activity.libraries = databricksLibraryToModel(modelActivity.typeProperties.libraries);
            });
        }

        activity.raw = JSON.stringify(await ValueAdapter.remainder(this.context, resource, SparkJarActivity.MODEL));

        return activity;
    }
}
